import request from '@/utils/request'

export function getRequireOrderList(data) {
  return request.post('/require-order/list', data)
}

export function addRequireOrder(data) {
  return request.post('/require-order/add', data)
}

export function modifyRequireOrder(data) {
  return request.post('/require-order/modify', data)
}

export function deleteRequireOrder(data) {
  return request.post('/require-order/delete', data)
}

export function listByGoods(data) {
  return request.post('/require-order/list-by-goods', data)
}

export function setDelivery(data) {
  return request.post('/require-order/set-delivery', data)
}

export function takeDeliveryOfRequireOrder(data) {
  return request.post('/require-order/take-delivery', data)
}

export function receiveRequireOrder(data) {
  return request.post('/require-order/receive', data)
}

export function issuedRequireOrder(data) {
  return request.post('/require-order/issued', data)
}

export function arrivedRequireOrder(data) {
  return request.post('/require-order/arrived', data)
}



// WEBPACK FOOTER //
// ./src/api/require/order.js